
import styles from './Spinner.module.scss'

export default function Spinner() {
  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.spinner} />
      </div>
    </div>
  )
}
